import React, { useRef } from "react";
import { useParams } from "react-router-dom";
import InBodyInterviewNotes from "@icoach/inbody/interview/InBodyInterviewNotesTable";
import InBodyInterviewMemberStateSummary from "@icoach/inbody/interview/InBodyInterviewMemberStateSummary";
import InBodyInterviewMeasure from "@icoach/inbody/interview/InBodyInterviewMeasureTable";
import { InBodyProvider } from "@icoach/inbody/components/InBodyContext";
import { Box } from "@curves/ui-base";
import { IN_BODY_INTERVIEW_TABS, MEASURE_REFERENCE_TYPE } from "@icoach/constants/";
import InBodyInterviewMeasureCompareTable from "@icoach/inbody/interview/InBodyInterviewMeasureCompareTable";
import InBodyInterviewMemberInfoSummary from "@icoach/inbody/interview/InBodyInterviewMemberInfoSummary";
import useGetMemberProfileState from "@util/hook/useGetMemberProfileState";
import { isEqual, toNumber } from "@util/utils";
import InBodyInterviewDialogBox from "@icoach/inbody/dialog/InBodyInterviewDialogBox";
import useGetMeasureRecordsState from "@util/hook/useGetMeasureRecordsState";

// 會員使用 不與教練頁共用
const InBodyInterviewPage = React.forwardRef((props, ref) => {
	const { referenceID: _peopleID, tabs: activeTab } = useParams();
	const peopleID = toNumber(_peopleID);
	const { memberProfile, ...memberProfileOther } = useGetMemberProfileState({ memberID: peopleID });

	const { measureData, validMeasureData, getInterviewMeasureApi } = useGetMeasureRecordsState({
		referenceType: MEASURE_REFERENCE_TYPE.MEMBER,
		referenceID: peopleID,
		isFetchOnMount: false,
	});

	const dialogRef = useRef(null);
	const refreshRef = useRef(() => {
		getInterviewMeasureApi();
		memberProfileOther.getMemberProfile();
	});

	return (
		<InBodyProvider
			value={{
				dialogRef,
				peopleID: peopleID,
                referenceType: MEASURE_REFERENCE_TYPE.MEMBER,
				memberProfile,
				...memberProfileOther,
				measureData,
				getInterviewMeasureApi,
				refresh: refreshRef.current,
				setRefresh: fn => (refreshRef.current = fn),
			}}
		>
			<Box className="container main-container-spacing inbody-interview">
				<InBodyInterviewMemberInfoSummary className="mb-3" sourceData={memberProfile} peopleID={peopleID} activeTab={activeTab} updateMeasureDay={memberProfileOther?.updateMeasureDay} />
				{isEqual(activeTab, IN_BODY_INTERVIEW_TABS.SUMMARY) && <InBodyInterviewMemberStateSummary sourceData={memberProfile}  />}
				{isEqual(activeTab, IN_BODY_INTERVIEW_TABS.COMPARE) && <InBodyInterviewMeasureCompareTable sourceData={validMeasureData} getInterviewMeasureApi={getInterviewMeasureApi} />}
				{isEqual(activeTab, IN_BODY_INTERVIEW_TABS.MEASURE) && <InBodyInterviewMeasure sourceData={validMeasureData} getInterviewMeasureApi={getInterviewMeasureApi} />}
				{isEqual(activeTab, IN_BODY_INTERVIEW_TABS.NOTES) && <InBodyInterviewNotes sourceData={measureData} getInterviewMeasureApi={getInterviewMeasureApi} />}
			</Box>
			<InBodyInterviewDialogBox ref={dialogRef} />
		</InBodyProvider>
	);
});

export default InBodyInterviewPage;
